import { styled } from '@linaria/react';
import { icons } from '../../../assets/icons/icons';

/**
 * The spinning Flora mark used as the "thinking" loader across Flora surfaces —
 * the flora-agent chat and the docked side panel — so the loading state reads
 * identically everywhere.
 *
 * @returns {JSX.Element} A 20px Flora icon rotating on a 1.2s loop.
 */
export const FloraSpinner = () => <SpinnerImg src={icons.iconFlora} alt="Loading" />;

const SpinnerImg = styled.img`
  width: 20px;
  height: 20px;
  animation: flora-spin 1.2s linear infinite;

  @keyframes flora-spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
`;
